import {
  MerchantUserUpdatePayload,
  UpdateMerchantUserServicesCommand,
} from "@/models/club";
import clubRequest from "../axios";
import { CreateUserPayload } from "./type";

const getMerchantUsers = async () =>
  (await clubRequest.merchantUserList()).data;

const getMerchantUserById = async (id: number) =>
  (
    await clubRequest.merchantUserDetail({
      id,
    })
  ).data;

const addMerchantUser = async (payload: CreateUserPayload) =>
  (await clubRequest.merchantUserCreate(payload)).data;

const updateMerchantUser = async (payload: MerchantUserUpdatePayload) =>
  (await clubRequest.merchantUserUpdate(payload)).data;

const updateMerchantUserServices = async (
  payload: UpdateMerchantUserServicesCommand
) => (await clubRequest.merchantUserServiceUpdate(payload)).data;

const merchantUserService = {
  addMerchantUser,
  getMerchantUsers,
  getMerchantUserById,
  updateMerchantUser,
  updateMerchantUserServices,
};

export default merchantUserService;
